// Central Pinia instance (isolated to avoid circular deps)
import { createPinia } from 'pinia'

export const pinia = createPinia()
export default pinia
